import { DialogComponent } from '@theme/dialog';

/**
 * Generic drawer component.
 * Desktop: slides in from the right as a side panel.
 * Mobile: slides up from the bottom as a full-screen sheet.
 *
 * Usage:
 *   <estro-drawer-component>
 *     <button on:click="/showDialog">Open</button>
 *     <dialog ref="dialog" class="estro-drawer__dialog">
 *       ...any content...
 *     </dialog>
 *   </estro-drawer-component>
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog
 *
 * @extends {DialogComponent<Refs>}
 */
class EstroDrawerComponent extends DialogComponent {}

if (!customElements.get('estro-drawer-component')) {
  customElements.define('estro-drawer-component', EstroDrawerComponent);
}
